import { forEachToken } from '@sail/engine';
import { tokens } from '@sail/tokens/deprecated';
import { property } from './util';
export const backgroundColor = property([
    tokens.color.background
]).accept();
export const borderColor = property([
    tokens.color.border
]).accept();
export const borderTopColor = property([
    tokens.color.border
]).accept();
export const borderRightColor = property([
    tokens.color.border
]).accept();
export const borderBottomColor = property([
    tokens.color.border
]).accept();
export const borderLeftColor = property([
    tokens.color.border
]).accept();
export const textColor = property([
    tokens.color.text
]).alias('color');
export const stroke = property([
    tokens.color.icon
]).accept();
export const fill = property([
    tokens.color.icon
]).accept();
/**
 * Please update `packages/tokens/tools/generate-sail-ui-color-relationships.ts`
 * if you are changing this function.
 */ function createColorRelationshipsMap() {
    const map = {};
    [
        'background',
        'border',
        'icon',
        'text'
    ].forEach((key)=>{
        forEachToken(tokens.color[key], (value, path)=>{
            if (key !== 'background') {
                var _map, _path;
                var _;
                (_ = (_map = map)[_path = path]) !== null && _ !== void 0 ? _ : _map[_path] = {};
                map[path][key] = value;
            }
            if (key === 'background' || key === 'border') {
                var _map1, _onPath;
                const onPath = path.replace(/^([a-z])/, (_, c)=>`on${c.toUpperCase()}`);
                var _1;
                (_1 = (_map1 = map)[_onPath = onPath]) !== null && _1 !== void 0 ? _1 : _map1[_onPath] = {};
                map[onPath][key] = value;
            }
        });
    });
    return map;
}
const relationshipsMap = createColorRelationshipsMap();
export const color = property([
    tokens.color.text
]).decorate(function color(// eslint-disable-next-line @typescript-eslint/ban-types
input, set) {
    if (input in relationshipsMap) {
        const relationships = relationshipsMap[input];
        relationships.border && set.property('borderColor', borderColor(relationships.border));
        relationships.background && set.property('backgroundColor', backgroundColor(relationships.background));
        relationships.text && textColor(relationships.text, set);
        relationships.icon && set.property('fill', fill(relationships.icon));
    } else {
        textColor(input, set);
        set.property('fill', fill(input));
    }
});

//# sourceMappingURL=propertiesColor.js.map